<template>
  <div class="">
    <el-card class="box-card">
      <!-- 原有注释的搜索表单代码：仅替换注释内显示文案 -->
      <!-- <div class="search-form" style="text-align: left">
        <el-form ref="searchForm" :inline="true" :model="searchForm" label-width="100px" label-position="left"
          class="demo-form-inline" size="small">
          <el-form-item label="	{{ $t('address.addressType') }}">
            <el-select v-model="searchForm.type" :placeholder="$t('address.addressType')">
              <el-option :label="$t('address.senderAddress')" :value="1"></el-option>
              <el-option :label="$t('address.recipientAddress')" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">{{ $t('address.query') }}</el-button>
            <el-button icon="el-icon-refresh-right" type="primary" size="small" @click="resetSearch">{{ $t('address.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div> -->
      <div class="" style="margin-bottom: 15px;text-align:left">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">{{ $t('address.addAddress')
          }}</el-button>
      </div>
      <el-table :data="dataList" border size="small" height="600">
        <el-table-column type="index" :index="indexMethod" :label="$t('address.serialNumber')"
          width="60"></el-table-column>
        <!-- 原有注释代码：仅替换注释内显示文案 -->
        <!-- <el-table-column prop="realname" :label="$t('address.nickname') " show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="realname" :label="$t('address.realname')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="country" :label="$t('address.country')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="province" :label="$t('address.province')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="city" :label="$t('address.city')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address_one" :label="$t('address.address1_2')" show-overflow-tooltip width="200">
          <template slot-scope="scope">
            <p>{{ scope.row.address_one }}</p>
            <p>{{ scope.row.address_two }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('address.mobile')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="zcode" :label="$t('address.zcode')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" :label="$t('address.email')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="user_type" :label="$t('address.type')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.user_type == 1 ? $t('address.senderAddress') : $t('address.recipientAddress') }}
          </template>
        </el-table-column>
        <!-- 原有注释代码：仅替换注释内显示文案 -->
        <!-- <el-table-column prop="remark" :label="$t('address.remark')" show-overflow-tooltip></el-table-column> -->
        <!-- 原有注释代码：仅替换注释内显示文案 -->
        <!-- <el-table-column prop="is_default" :label="$t('address.defaultAddress')" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_default" active-color="#13ce66" :inactive-value='0' :active-value='1' @change='(checked) => handleChangeDefault(checked, scope.row.id)'></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column prop="action" :label="$t('address.operation')" width="140">
          <template slot-scope="scope">
            <div>
              <span style="color: #409eff; cursor: pointer" @click="handleEdit(scope.row)">{{ $t('address.edit')
                }}</span>
              <el-divider direction="vertical"></el-divider>
              <span style="color: #f40000; cursor: pointer" @click="handleDel(scope.row)">{{ $t('address.delete')
                }}</span>
              <el-divider direction="vertical" v-if="isType"></el-divider>
              <span style="color: #B2AE10; cursor: pointer" @click="handleSelect(scope.row)" v-if="isType">{{
                $t('address.select') }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagization-box">
        <CustomPagization :background="true" :currentPage="current" :total="total" :pageSize="size"
          @current-change="currentChange" />
      </div>
    </el-card>

    <!-- 表单弹窗 -->
    <el-dialog :close-on-click-modal="false" :title="title" append-to-body :visible.sync="formVisible" width="900px"
      :before-close="closeDialog">
      <Form ref="formModal" :record="record" v-if="formVisible" @ok="editSuccess" append-to-body />
    </el-dialog>
  </div>
</template>

<script>
import Form from "./form";
import { address, addressDel } from '@/api/address'
export default {
  props: {
    isType: {
      type: [Number, String],
      default: ''
    }
  },
  components: {
    Form,
  },
  data() {
    return {
      formVisible: false,
      record: {},
      title: '', // 初始化标题为空
      searchForm: {},
      current: 1,
      size: 20,
      total: 1,
      dataList: [],
    };
  },
  mounted() {
    if (this.isType) {
      this.searchForm.address_type = this.isType
    }
    this.getAddress()
  },
  methods: {
    // 原有注释代码：仅替换注释内显示文案
    // 开关设置默认地址
    // handleChangeDefault(e,id){
    //   defaultUpdate({
    //     user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
    //     address_id: id
    //   }).then(res => {
    //     if(res.code == 1){
    //       this.$message.success(res.msg);
    //       this.getAddress();
    //     }else{
    //       this.$message.success(res.msg);
    //     }
    //   })
    // },
    // 获取列表
    getAddress() {
      address({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        page: this.current,
        limit: this.size,
        ...this.searchForm
      }).then(res => {
        if (res.code == 1) {
          this.dataList = []
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.record = {};
      this.formVisible = false;
    },
    //新增、修改成功的回调
    editSuccess() {
      this.formVisible = false;
      this.getAddress();  //刷新列表
    },
    //视频监控站点新增
    handleAdd() {
      this.title = this.$t('address.add')
      this.record = {}
      this.formVisible = true
    },
    //视频监控站点修改
    handleEdit(record) {
      this.title = this.$t('address.editAddress')
      this.record = {
        ...record
      }
      this.formVisible = true
    },
    //视频监控站点删除
    handleDel(record) {
      const _that = this;
      this.$confirm(this.$t('address.confirmDelete'), this.$t('address.warmTips'), {
        type: "warning",
      })
        .then(() => {
          addressDel({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            id: record.id
          }).then(res => {
            if (res.code == 1) {
              this.current = 1
              this.$message.success(res.msg);
              this.getAddress();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },
    //新增、修改成功的回调
    editSuccess() {
      this.formVisible = false
      this.getAddress();
    },
    // 选择地址
    handleSelect(scope) {
      this.$emit('ok', scope, this.isType)
    },
    // table首列序号
    indexMethod(index) {
      return (this.current - 1) * this.size + index + 1;
    },
    // 页数变化
    currentChange(current) {
      this.current = current;
      this.getAddress();
    },
    // 重置筛选
    resetSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchForm = {}
      this.value1 = []
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.handleSearch();
    },
    // 去筛选
    handleSearch() {
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.getAddress();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}

/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;

      & th {
        background-color: transparent;
      }

      & tr {
        background-color: transparent;
      }
    }
  }
}
</style>